import { createReducer } from '../../utils/misc'

import {
  FETCH_SOLICITUDES_CREDITOS_REQUEST,
  FETCH_SOLICITUDES_CREDITOS_SUCCESS,
  FETCH_SOLICITUDES_CREDITOS_ERROR,
  FETCH_SOLICITUD_CREDITO_REQUEST,
  STOP_LOADING_MODAL,
  FETCH_SOLICITUD_CREDITO_SUCCESS,
  FETCH_SOLICITUD_CREDITO_ERROR,
  CLEAR_SOLICITUD_CREDITO,
  ASSIGN_SOLICITUD_CREDITO_ERROR,
  ASSIGN_SOLICITUD_CREDITO_REQUEST,
  ASSIGN_SOLICITUD_CREDITO_SUCCESS,
  UNLOCK_SOLICITUD_CREDITO_ERROR,
  UNLOCK_SOLICITUD_CREDITO_REQUEST,
  UNLOCK_SOLICITUD_CREDITO_SUCCESS,
  FETCH_MOTIVOS_RECHAZO_FILE_SUCCESS,
  FETCH_MOTIVOS_RECHAZO_FILE_ERROR,
  FETCH_FILE_REVIEW_SUCCESS,
  FETCH_FILE_REVIEW_ERROR,
  SEND_ID_OFERTA_SUCCESS,
  CLOSE_MODAL_SOLICITUD,
  SHOW_MODAL_SOLICITUD,
  SEND_ID_OFERTA_ERROR,
  FETCH_MOTIVOS_RECHAZO_SOLICITUD_SUCCESS,
  FETCH_MOTIVOS_RECHAZO_SOLICITUD_ERROR,
  FETCH_REJECT_SOLICITUD_CREDITO_SUCCESS,
  FETCH_REJECT_SOLICITUD_CREDITO_ERROR,
  CHANGE_TO_DOCUMENTS_READY_SUCCESS,
  CHANGE_TO_DOCUMENTS_READY_ERROR,
  CHANGE_TO_ACTIVATE_CREDIT_SUCCESS,
  CHANGE_TO_ACTIVATE_CREDIT_ERROR,
  RESET_ID_OFERTA_ERROR,
} from "../constants/backOffice"

const initialState = {
  solicitudesCreditos: [],
  itemCount: 0,
  pageCount: 0,
  fetchingSolicitudes: false,
  errorSolicitudesCreditos: null,
  assigningSolicitud: false,
  errorSolicitudAssignment: null,
  solicitudCredito: {
    datosAfiliado: {
      rut: '',
      nombre: '',
      banco: '',
      tipoCuenta: '',
      numeroCuenta: '',
      numeroSerie: '',
    },
    datosCredito: {
      montoSolicitado: '',
      numeroCuotas: '',
      segCesantia: '',
      tipo: '',
      tipoTrabajador: '',
      beneficioSocial: ''
    },
    documentos: [
      {
        nombre: '',
        path: '',
        estadoDocumento: undefined,
        motivoRechazoFileId: undefined,
        fileId: null,
        tipo: null,
      },
    ],
    idOferta: '',
    estadoSolicitud: '',
    folio: '',
    estadoCCR: '',
    motivoRechazoSolicitudCreditoId: undefined,
    solicitudCreditoId: null,
    fechaEnvio: '',
    error: null,
    fetchingSolicitud: false,
    errorFileReview: null,
    errorIdOfertaEconomica: null,
    errorRejectSolicitud: null,
    errorDocumentsReady: null,
    errorActivateCredit: null,
  },
  motivosRechazoFile: [],
  motivosRechazoSolicitud: [],
  modalIsOpen: false,
}

export default createReducer(initialState, {
  [FETCH_SOLICITUDES_CREDITOS_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingSolicitudes: true,
    }),
  [FETCH_SOLICITUDES_CREDITOS_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitudes: false,
      solicitudesCreditos: payload.solicitudesCreditos,
      itemCount: payload.itemCount,
      pageCount: payload.pageCount,
    }),
  [FETCH_SOLICITUDES_CREDITOS_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitudes: false,
      solicitudesCreditos: [],
      errorSolicitudesCreditos: payload,
    }),
  [FETCH_SOLICITUD_CREDITO_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingSolicitud: true,
    }),
  [STOP_LOADING_MODAL]: state =>
    Object.assign({}, state, {
      fetchingSolicitud: false,
    }),
  [FETCH_SOLICITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitud: false,
      solicitudCredito: payload,
    }),
  [FETCH_SOLICITUD_CREDITO_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitud: false,
      solicitudCredito: {
        ...initialState.solicitudCredito,
        error: payload,
      },
    }),
  [CLEAR_SOLICITUD_CREDITO]: state =>
    Object.assign({}, state, {
      fetchingSolicitud: false,
      solicitudCredito: initialState.solicitudCredito,
    }),
  [ASSIGN_SOLICITUD_CREDITO_REQUEST]: state =>
    Object.assign({}, state, {
      assigningSolicitud: true,
    }),
  [ASSIGN_SOLICITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      assigningSolicitud: false,
      errorSolicitudAssignment: null,
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.solicitudId
          ? {
              ...s,
              usuarioAsignado: payload.user.username,
              userId: payload.user.id,
            }
          : s,
      ),
    }),
  [ASSIGN_SOLICITUD_CREDITO_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      assigningSolicitud: false,
      errorSolicitudAssignment: payload,
    }),
  [UNLOCK_SOLICITUD_CREDITO_REQUEST]: state =>
    Object.assign({}, state, {
      unlockSolicitud: true,
    }),
  [UNLOCK_SOLICITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      unlockSolicitud: false,
      errorSolicitudUnlock: null,
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.solicitudId
          ? {
              ...s,
              usuarioAsignado: payload.usuarioAsignado,
              userId: payload.userId,
            }
          : s,
      ),
    }),
  [UNLOCK_SOLICITUD_CREDITO_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      unlockSolicitud: false,
      errorSolicitudUnlock: payload,
    }),
  [FETCH_MOTIVOS_RECHAZO_FILE_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      motivosRechazoFile: payload,
    }),
  [FETCH_MOTIVOS_RECHAZO_FILE_ERROR]: state =>
    Object.assign({}, state, {
      motivosRechazoFile: [],
    }),
  [FETCH_MOTIVOS_RECHAZO_SOLICITUD_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      motivosRechazoSolicitud: payload,
    }),
  [FETCH_MOTIVOS_RECHAZO_SOLICITUD_ERROR]: state =>
    Object.assign({}, state, {
      motivosRechazoSolicitud: [],
    }),
  [FETCH_FILE_REVIEW_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.id
          ? { ...s, estadoSolicitud: payload.status }
          : s,
      ),
      solicitudCredito: {
        ...state.solicitudCredito,
        estadoSolicitud: payload.status,
      },
      errorFileReview: null,
    }),
  [FETCH_FILE_REVIEW_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorFileReview: payload,
      },
    }),
  [FETCH_REJECT_SOLICITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.id
          ? { ...s, estadoSolicitud: payload.status }
          : s,
      ),
      errorRejectSolicitud: null,
    }),
  [FETCH_REJECT_SOLICITUD_CREDITO_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorRejectSolicitud: payload,
      },
    }),
  [SEND_ID_OFERTA_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.solicitudCredito.id
          ? {
              ...s,
              estadoSolicitud: payload.solicitudCredito.status,
              usuarioAsignado: payload.user.username,
            }
          : s,
      ),
      errorIdOfertaEconomica: null,
    }),
  [SEND_ID_OFERTA_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorIdOfertaEconomica: payload,
      },
    }),
  [CHANGE_TO_DOCUMENTS_READY_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.id
          ? {
              ...s,
              estadoSolicitud: payload.solicitudCredito.status,
              usuarioAsignado: payload.user.username,
            }
          : s,
      ),
      errorDocumentsReady: null,
    }),
  [CHANGE_TO_DOCUMENTS_READY_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorDocumentsReady: payload,
      },
    }),
  [CHANGE_TO_ACTIVATE_CREDIT_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      solicitudesCreditos: state.solicitudesCreditos.map(s =>
        s.solicitudId === payload.id
          ? {
              ...s,
              estadoSolicitud: payload.solicitudCredito.status,
              usuarioAsignado: payload.user.username,
            }
          : s,
      ),
      errorActivateCredit: null,
    }),
  [CHANGE_TO_ACTIVATE_CREDIT_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorActivateCredit: payload,
      },
    }),
  [SHOW_MODAL_SOLICITUD]: state =>
    Object.assign({}, state, {
      modalIsOpen: true,
    }),
  [CLOSE_MODAL_SOLICITUD]: state =>
    Object.assign({}, state, {
      modalIsOpen: false,
    }),
  [RESET_ID_OFERTA_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      solicitudCredito: {
        ...state.solicitudCredito,
        errorIdOfertaEconomica: payload,
      },
    }),
})
